<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Approved Incident</strong>
                    </div>

                    <!-- <b-row>
                        
                    </b-row> -->

                    <b-row>
                        <b-col md="4">
                            
                            <b-form-group label="Select Vehicle" :label-cols="4">
                             <v-select v-model="vehicle_id" :options="data1" placeholder="-- Select Vehicle--" :disabled="checkedload.length ==0"></v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2">
                            <b-button variant="primary" @click="updatevehicle()" :disabled="checkedload.length ==0">Update</b-button>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label-cols-sm="3" label="Search : " class="mb-0">
                                <b-input-group>
                                  <b-form-input v-model="filter" placeholder="Search..."></b-form-input>
                                  <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col md="2">
                            <b-button variant="primary"> Increase EDD </b-button>
                        </b-col> -->
                    </b-row>

                    <br>
                    <div>
                    <b-row>
                        <b-col md="6">
                        <input type='checkbox' @click='checkAll()' v-model='isCheckAll' :disabled="totalcount==0"> 
                        <span > Select All </span>
                        </b-col>
                        <b-col md="6">
                            <div class="text-right">
                               <h6><b>Total Records : <span style="color: red;">{{ totalcount}}</span></b></h6>
                            </div>
                        </b-col>
                    </b-row>
                        <b-table show-empty  responsive :fields="fields" :items="approvecount" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                              </div>
                                <template slot="select" slot-scope="row">
                                    <b-form-group>
                                        <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="row.item.load_id" @change="multiselectdesign($event,row.item)"  v-model='checkedload' />
                                    </b-form-group>
                                </template>
                                <template slot="update_vehicle_no" slot-scope="row">
                                    <span v-if="row.item.is_vehicle_changed==1">
                                        {{row.item.update_vehicle_no}}
                                    </span>
                                </template>
                                <template slot="estimated_delivery_datetime" slot-scope="row">
                                    {{ row.item.estimated_delivery_datetime }}&nbsp;
                                
                                  <i class="fa fa-pencil-square" style="font-size: 23px;
                                  color: #174895; cursor: pointer;" title="Edit Date"
                                  @click="editestimated_delivery_datetime(row.item)"></i>
                                
                                </template>
                        </b-table>
                    </div>

                    <div class="text-right">
                        <b-button v-if="approveFlag==true" type="submit" size="md" class="mr-4" variant="success" @click="approveVehicle(1)">Approve</b-button>
                        <b-button v-else v-b-modal.modal-approvevehicle type="submit" size="md" class="mr-4" variant="success">Approve</b-button>
                    </div>

                    <b-modal title="Increase Estimated Delivery Datetime" v-model="editestimateddatetime" @ok="editestimateddatetime==false" size="md" hide-footer>
                        <b-form-group label="From Date:"  :label-cols="3" >
                            <v-date-picker mode='single' 
                                input-class="dateInput" :available-dates='{ start: new Date(), end: null }' v-model='selectDate'>
                           </v-date-picker>
                        </b-form-group>
                        <br><br>
                        <b-button variant="primary" class="float-right" @click="Increasedate(selectDate)">Update</b-button>
                    </b-modal>

                    <b-modal id="modal-approvevehicle" title="Confirmation Box" hide-footer>
                        <p class="my-1">Are you sure you want to Continue?</p>
                        <b-button variant="primary" class="float-right" size="sm" @click="approveVehicle(0)">OK</b-button>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    props: ['incidentlevel', 'vehicleid'],
    data() {
        return {
            filter: null,
            fields: [
                { key : "select", label : "Select"},
                { key: "load_id",  label: "Load ID"},
                { key: "no_of_boxes",  label: "No of Boxes"},
                { key: "load_status",  label: "Load status"},
                { key: "ewaybill",  label: "Eway Bill"},
                { key: "vehicle_no",  label: "Vehicle No"},
                { key: "update_vehicle_no",  label: "Update Vehicle No",variant:"success"},
                { key: "ewaybill_validity",  label: "Ewaybill Validity"},
                { key: "dispatch_date",  label: "Dispatch Date"},
                { key: "estimated_delivery_datetime",  label: "EDD"},
            ],
            approvecount :[],
            isBusy :false,
            modalShow :false,
            route_id : '',
            isCheckAll : false,
            checkedload :[],
            selectload :[],
            selectload_id :[],
            data1 :[],
            vehicle_id :'',
            totalcount :0,
            vehiclenumber :[],
            approveFlag:false,
            parentAwb:[],
            editestimateddatetime :false,
            selectDate : new Date(),
            modelvehicle_id : '',
            modelloadid : '',
        }
    },

    mounted() {
        console.log('Report ID:', this.$route.params.report_id);
        console.log('Incident Level:', this.$route.query.incidentlevel);
        console.log('vehicleid Level:', this.$route.query.vehicleid);
        // You can use the data as needed in your component
    }, 
    created() {
        this.route_id = this.$route.params.id;
    //   console.log("this.router_id", this.route_id);
        this.approveopenincident();
        this.getvehiclelist();
    },

    methods: {
        editestimated_delivery_datetime (value){
            console.log("@@@@@",value)
            this.modelvehicle_id = '';
            this.modelvehicle_id = value.vehicle_id;
            this.modelloadid = value.load_id;
            this.editestimateddatetime =! this.editestimateddatetime
        },

        Increasedate(selected_date){
            document.getElementById("overlay").style.display = "block";
            console.log("@@@@@@@@@@@",selected_date)
            var increasdate = (selected_date!=null)?this.formatDate(selected_date):"";
            console.log("fromdate",increasdate)

            const obj = {
                vehicle_id : this.$route.query.vehicleid,
                estimated_delivery_datetime : increasdate,
                load_id: this.modelloadid,
            }
            console.log("000000",obj)

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/increaseEDD`,obj).then((result)=>{
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.editestimateddatetime = false;
                    this.approveopenincident();
                } else {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
            
        },

        checkAll: function(){

            this.isCheckAll = !this.isCheckAll;
            this.checkedload = [];
            this.selectload = [];
            this.selectload_id = [];
            // console.log("selectload_id", this.selectload_id);
            if(this.isCheckAll){ // Check all

            for (var key in this.approvecount) {
                // console.log("this.approvecount",this.approvecount)
                this.checkedload.push(this.approvecount[key].load_id);
                // console.log("this.checkedParentAWB",this.checkedload);
                }
            }
        },

        multiselectdesign(e,value){

            if (this.checkedload.length >=0)
            console.log("check",this.checkedload.length)
            {
                if (e.target.checked==true){
                    if(this.checkedload.length == this.approvecount.length){
                        this.isCheckAll = true;
                    }
                
                }else{
                   
                        this.isCheckAll = false;
                
                }

            }
        },

        approveopenincident : function () {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.isBusy = true;
            let count = 0;
            this.parentAwb=[];
            const obj = {
                report_id : this.route_id,
                report_status: "open", 
            }
            console.log(obj)
            // return false

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getReportAgainstLoad`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusy = false;
                if (result.body.returnmsg==="Successful") {
                    this.approvecount = result.body.returnvalue;
                    console.log("uuuuuuuuuuuu",this.approvecount)
                    for (let i = 0; i < this.approvecount.length; i++) {
                        this.parentAwb.push(this.approvecount[i].load_id)
                        let number = this.approvecount[i].vehicle_id;
                        this.vehiclenumber=number;
                        if(this.approvecount[i].is_vehicle_changed==1){
                            count++;
                        }
                    }
                    this.totalcount = result.body.returnvalue.length;
                    if(this.totalcount==count){
                        this.approveFlag=true
                    }

                    
                } else {
                    this.approvecount = result.body.returnvalue;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        getvehiclelist: function() {
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)

            const vehicleagent = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,
                isactive:'1',
                vehicle_type : "bulkreallocate"
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`, vehicleagent)
            .then((result) => {

                // this.isBusy = true;
                this.data1 = result.body;
                // console.log("ooooo",this.vehiclenumber)
                var data = [];
                
                this.data1.forEach(function (srData) {
                    if (srData.vehicle_id && srData.vehicle_no && srData.vehicle_name) {
                        data.push({
                            key:srData.vehicle_id,
                            label:srData.vehicle_no + "-" + srData.vehicle_name.substring(0, 6) 
                        });
                    }
                  
                    });
                    this.data1 = data;
                    console.log(this.data1)

            })
            .catch((ex) => {
            console.log('error', ex)
            })

        },

        updatevehicle : function () {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            if (this.vehicle_id == null) {
                this.$fire({
                        text:'Plaese Select Vehicle Number',
                        type: "warning",
                        timer: 30000
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false
            }
            if (this.vehiclenumber == this.vehicle_id.key) {
                this.$fire({
                        text:'Plaese Select other Vehicle Number',
                        type: "warning",
                        timer: 30000
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false
                    
            }
            const obj = {
                report_status : "open",
                report_id : this.route_id,
                parent_awb: this.checkedload,
                vehicle_id : this.vehicle_id.key,
                lastmodifiedby : `${userInfo.userfirstname} ${userInfo.userlastname}`,
            }
            console.log("obj",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateVehicleAgainstLoad`,obj)
            .then(result =>{
                document.getElementById("overlay").style.display = "none";
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    
                    this.checkedload = [];
                    this.selectload = [];
                    this.selectload_id = [];
                    this.isCheckAll= false;
                    this.vehicle_id='';
                    this.approveopenincident();
                    // this.$router.push('/approve_incident')
                } else {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        approveVehicle(value){
            
            console.log(value)
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj = {
                report_status : "Approved",
                report_id : this.route_id,
                parent_awb: this.parentAwb,
                incidentlevel : this.$route.query.incidentlevel,
                // vehicle_id : this.vehicle_id.key,
                lastmodifiedby : `${userInfo.userfirstname} ${userInfo.userlastname}`,
                updatedFlag : value,

            }
            console.log("@@@@@@@@@@",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveIncidentReport`,obj).then((result)=>{
            document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    
                    this.$router.push('/approve_incident')
                } else {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
            
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>